import axios from 'axios';
import { useState } from 'react';
import { BASE_URL } from 'utils/constants/Api';

import { useUser } from '@project44/ui-utils';

type TChatDiscussionResponse = {
  discussionId: string;
};

const useChatDiscussion = () => {
  const { data: user } = useUser();
  const [discussionId, setDiscussionId] = useState('');

  const startNewDiscussion = async () => {
    try {
      const { data } = await axios.post<TChatDiscussionResponse>(
        `${BASE_URL}/movement-chatbot/discussion`,
        {
          userId: user?.id.toString(),
          tenantId: user?.tenantId.toString(),
        },
        {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      setDiscussionId(data.discussionId);
      return data.discussionId;
    } catch (_e) {}
  };

  return {
    discussionId,
    startNewDiscussion,
  };
};

export default useChatDiscussion;
